import React, { Component } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import loading from './assets/loading.json';
import success from './assets/success.json';
import fail from './assets/fail.json';
import pending from './assets/pending.json';
import TEST_STATUS from '../../constants/status';

class CompatabilityIndicator extends Component {
	render() {
		const { state, messages } = this.props;

		let src;
		switch (state) {
			case TEST_STATUS.loading:
				src = loading;
				break;
			case TEST_STATUS.success:
				src = success;
				break;
			case TEST_STATUS.fail:
				src = fail;
				break;
			case TEST_STATUS.pending:
				src = pending;
				break;
		}

		return (
			<div className="compatability-check">
				<div>
					<Player src={src} autoplay loop style={{ width: 52, height: 52 }} />
				</div>
				<span className="compatability-check-message">{messages[state]}</span>
			</div>
		);
	}
}

export default CompatabilityIndicator;



// WEBPACK FOOTER //
// ./src/components/tech-check/CompatabilityIndicator.js